<template>
  <v-app-bar app color="bgPrimary" elevation="1" dense>
    <!-- <v-app-bar-nav-icon @click="drawer = !drawer" class="color-icon">
    </v-app-bar-nav-icon> -->
    <!-- <v-toolbar-title class="title">{{ title }}</v-toolbar-title> -->
    <v-spacer></v-spacer>
    <u-upload-popup></u-upload-popup>
    <u-notification-popup />
    <u-profile-popup
      :image="image"
      :firstName="firstName"
      :lastName="lastName"
      :subtitle="subtitle"
    ></u-profile-popup>
  </v-app-bar>
</template>

<script>
export default {
  data () {
    return {
      items: [...Array(0)].map((_, i) => {
        return { text: `Real-Time-${i}`, icon: 'mdi-clock' }
      })
    }
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Untitled'
    },
    value: {
      type: Boolean,
      default: false
    },
    firstName: {
      type: String,
      default: 'Untitled'
    },
    lastName: {
      type: String,
      default: 'Untitled'
    },
    image: {
      type: String,
      default: 'Untitled'
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    drawer: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  }
}
</script>

<style lang="css" scoped>
.title {
  font-family: "Kanit", sans-serif !important;
  font-size: 25px !important;
  font-weight: 300 !important;
  color: var(--v-tprimary-base);
}
.title::first-letter {
  font-weight: 600;
  color: #55cfe5;
}
.color-icon {
  color: var(--v-tprimary-base) !important;
}
</style>
